export const randomPointInsideCircle = (
  x: number,
  y: number,
  radius: number
) => {
  const r = radius * Math.sqrt(Math.random());
  const theta = Math.random() * 2 * Math.PI;
  return { x: x + r * Math.cos(theta), y: y + r * Math.sin(theta) };
};
